module.exports = __webpack_public_path__ + "static/media/person-icon.270b6a98.svg";